import moment from 'moment'
import {cloneDeep, isString} from "lodash";

export function formatPrice(price) {
    let formatValue = price * 1
    if (isNaN(formatValue)) {
        formatValue = 0
    }
    formatValue = formatValue.toFixed(2)
    return `￥${formatValue}`
}

export function fileReader(file) {
    const fileReader = new FileReader();

    return new Promise((resolve, reject) => {
        fileReader.onerror = () => {
            fileReader.abort();
            reject(new Error('Problem parsing file'));
        };

        fileReader.onload = () => {
            resolve(fileReader.result);
        };

        fileReader.readAsText(file);
    });
}

/**
 * 格式化Date对象到日期字符串
 * @param {Date} date
 * @param {boolean} endOfDay 是否到当天结束时间
 */
export function dateToString(date, endOfDay = false) {
    const time = moment(date)
    if (endOfDay) {
        time.endOf('day')
    }
    return time.format('YYYY-MM-DD HH:mm:ss')
}

/**
 * 格式化Date对象到日期字符串
 * @param {string} dateStr
 */
export function stringToDate(dateStr) {
    return moment(dateStr).toDate()
}

export function downloadImg(imgName = undefined, imgUrl) {
    return new Promise(resolve => {
        const x = new XMLHttpRequest();
        x.open("GET", imgUrl, true);
        x.responseType = 'blob';
        x.onload = function (e) {
            const url = window.URL.createObjectURL(x.response);
            const a = document.createElement('a');
            a.href = url
            a.download = imgName
            a.click()
            resolve(true)
        }
        x.send();
    })
}

export function formatParams(params) {
    let queryParams = cloneDeep(params)
    if (params.date_range?.length) {
        queryParams.query.createdAt = `>=${params.date_range[0]}<=${params.date_range[1]}`
    }

    if (params.field && params.content) {
        queryParams.query[params.field] = `%${params.content}%`
    }

    return queryParams
}

export function numberEncryption(v) {
    v = v.toString()
    if (!v) return v
    const reg = /(\d{3})\d*(\d{4})/
    return v.replace(reg, '$1****$2')
}


